module.exports = __webpack_public_path__ + "static/media/Style8.3e94638c.PNG";